import { NgModule } from '@angular/core';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { DropdownComponent } from './dropdown.component';
@NgModule({
  declarations: [
    DropdownComponent
  ],
  imports: [
    NgxUiLoaderModule,
  ],
  exports:[DropdownComponent],
})
export class dropdownModule { }
